/**
 * Gets a value from a nested object. Curried.
 *
 * Use: get( ['user', 'posts', 0, 'comments'] )( object )
 *
 * @see https://medium.com/javascript-inside/safely-accessing-deeply-nested-values-in-javascript-99bf72a0855a
 *
 * @param path Array
 * @param object
 */
export const get = path => ( object, defaultValue = null ) =>
	path.reduce( ( xs, x ) =>
	( xs && xs[ x ] ) ? xs[ x ] : defaultValue, object )

export const loop = ( items, callback, sortKeys = false ) => {
	if ( ! items || ! Object.keys( items ).length ) {
		return
	}

	if ( ! sortKeys ) {
		sortKeys = Object.keys( items )
	}

	return sortKeys.map( key => {
		return callback( key, items[ key ] )
	} )
}

/**
 * Returns a new object with a key:value pair inserted before a given existing key.
 */
export function insertIntoObjectBeforeKey( object, key, value, afterKey ) {
	return Object.keys( object ).reduce( ( acc, cur, idx, src ) => {
		if ( cur === afterKey ) {
			acc[ key ] = value
		}

		acc[ cur ] = object[ cur ]

		return acc
	},
	{} )
}

/**
 * Returns a new object with a key:value pair inserted after a given existing key.
 */
export function insertIntoObjectAfterKey( object, key, value, afterKey ) {
	return Object.keys( object ).reduce( ( acc, cur, idx, src ) => {
		acc[ cur ] = object[ cur ]

		if ( cur === afterKey ) {
			acc[ key ] = value
		}

		return acc
	},
	{} )
}

/**
 * Returns the next key in an object after the given key.
 */
export function getNextKeyInObject( afterKey, object ) {
	let returnValue = false
	let isNext = false

	if ( ! object || ! 'object' == typeof object ) {
		return returnValue
	}

	Object.keys( object ).some( key => {
		if ( key === afterKey ) {
			isNext = true

			return false
		}

		if ( isNext ) {
			returnValue = key

			return true
		}
	} )

	return returnValue
}

export function jsonEqual( a, b ) {
	return JSON.stringify( a ) === JSON.stringify( b )
}
